import { CssBaseline, ThemeProvider } from "@mui/material";
import { useNavigate, useRoutes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThemeSettings } from "./theme/Theme";
import ScrollToTop from "./components/shared/ScrollToTop";
import Router from "./routes/Router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingModal from "./components/loading/loading";
import {
  Checkuser,
  dataLocalStorage,
  getLocalStorage,
} from "./helper/publicFunction";
import { useEffect } from "react";
import CommonAlertComponent from "./components/alert/CommonAlert";
import "./app.css";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setupAxiosInterceptors } from "./common/axiosSetup";

function App() {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setupAxiosInterceptors();
  }, []);

  const queryClient = new QueryClient();

  useEffect(() => {
    Checkuser({ dispatch, navigate });

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleBeforeUnload = (event) => {
    if (getLocalStorage(dataLocalStorage.loading_check_user) === true) {
      event.preventDefault();
      event.returnValue =
        "You have an ongoing API request. Are you sure you want to leave?";
    }
  };
  // const libraries = ["geometry", "drawing", "places"];
  // const { isLoaded } = useJsApiLoader({
  //   id: "google-map-script",
  //   googleMapsApiKey: "AIzaSyA803tGWjqiLXlzocmqqM0vqGyHxT2yOI0",
  //   libraries: libraries,
  // });

  // useEffect(() => {
  //   if (isLoaded) {
  //     localStorage.setItem("isGoogleMapsLoaded", JSON.stringify(isLoaded));
  //   }
  // }, [isLoaded]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ScrollToTop>
          {/* <CommonAlertComponent /> */}
          {routing}
        </ScrollToTop>
        {/* <ReactQueryDevtools initialIsOpen={false} position="left" /> */}
        <ToastContainer
          position="bottom-right"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          toastClassName="custom-toast"
        />
        <LoadingModal />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
